import { IconName } from "#shared/icons/Icon";
import { PartTypeSchema, PartTypeType } from "shared";

import { partTypesWordingMap } from "./PartTypesWordingMap";

export const iconForPartType: Record<PartTypeType, IconName> = {
  ASSEMBLY: "cube",
  SHEET: "sheet",
  MACHINING: "billet",
  ROUND_TUBE: "roundTube",
  SQUARE_TUBE: "squareTube",
  RECTANGULAR_TUBE: "rectangularTube",
  ROUND_BAR: "roundBar",
  SQUARE_BAR: "billet",
  PROFILE: "nut",
  CONSUMABLE: "nut",
  OTHER: "nut",
};

export type PartTypeOption = {
  value: PartTypeType;
  label: string;
  icon: IconName;
};

export const SELECTABLE_PART_TYPES = new Set<PartTypeType>([
  PartTypeSchema.enum.SHEET,
  PartTypeSchema.enum.MACHINING,
  PartTypeSchema.enum.ROUND_TUBE,
  PartTypeSchema.enum.SQUARE_TUBE,
  PartTypeSchema.enum.RECTANGULAR_TUBE,
  PartTypeSchema.enum.ROUND_BAR,
  PartTypeSchema.enum.SQUARE_BAR,
  PartTypeSchema.enum.CONSUMABLE,
  PartTypeSchema.enum.PROFILE,
  PartTypeSchema.enum.OTHER,
]);

export function getSelectablePartTypeOptions(currentType?: PartTypeType | null): PartTypeOption[] {
  return (Object.entries(partTypesWordingMap) as [PartTypeType, string][])
    .filter(([type]) => SELECTABLE_PART_TYPES.has(type) || type === currentType)
    .map(([value, label]) => ({ value, label, icon: iconForPartType[value] }));
}
